import * as React from "react";
import { Icon } from "semantic-ui-react";
import styled from "styled-components";
import Typography from "components/atoms/Typography/Typography";
import { definedTypographyTypes } from "components/atoms/Typography/TypographyStyles";
import ResponsiveCardHeader from "components/atoms/Text/ResonsiveCardHeader";
import TildeTranslate from "components/atoms/Text/TildeTranslate";
import { removeLinkProtocol } from "helpers/globalFunctions";
import MediaRating from "components/organisms/MediaRating/MediaRating";
import { ILinkEntityDisplay } from "api/types/LinkEntity";

import EventImage, {
  definedAspectRatios,
} from "../Images/EventImage/EventImage";
import EventDetailList, {
  IEventDetailListProps,
} from "../List/EventDetailList";

interface IMediaLinkProps {
  card: ILinkEntityDisplay;
  disabled?: boolean;
}

const StyledCardWrapper = styled.div<{ disabled?: boolean }>(
  ({ disabled, theme }) => ({
    width: "auto",
    maxWidth: "100%",
    // in case we need to have just visual card, without option to click on it (e.g. in profile view)
    pointerEvents: disabled ? "none" : "auto",
    ":hover": {
      transform: "translateY(-3px)",
      boxShadow: theme.boxShadows.light,
    },
  }),
);

const StyledLinkArea = styled.div(({ theme }) => ({
  color: theme.palette.primary.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "0.3em",
  ".mediaSource": {
    [`@media (min-width: ${theme.breakpoints.mobile[1]})`]: {
      fontSize: "0.7rem !important",
    },
    marginRight: "0.4em !important",
  },
  overflow: "hidden",
  flexFlow: "wrap",
  ".linkLabel": {
    maxWidth: "50%",
    marginRight: "auto",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
}));

const StyledInfoArea = styled.div({
  display: "flex",
  padding: "0 1em",
  alignContent: "center",
  justifyContent: "space-between",
});
const MediaLinkCard: React.FC<IMediaLinkProps> = ({ card, disabled }) => {
  const {
    id,
    title,
    url,
    createdAt,
    imageUrl,
    mediaSource,
    countries,
    mediaSourceInfo,
  } = card;
  const detailProps: Partial<IEventDetailListProps> = {};
  detailProps.date = createdAt || (card as any).created;
  detailProps.countries = countries;
  const rating = mediaSourceInfo?.ratingAverage || 0;

  return (
    <StyledCardWrapper disabled={disabled} id={id}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <EventImage
          imageUrl={imageUrl}
          aspectRatio={definedAspectRatios.aspect16to9}
        >
          <StyledLinkArea>
            <div className="linkLabel">
              <Icon name="linkify" size="large" />
              <Typography
                className="mediaSource"
                type={definedTypographyTypes.h5}
                margin="0"
              >
                {mediaSource && removeLinkProtocol(mediaSource)}
              </Typography>
            </div>
            <MediaRating disabled defaultRating={rating} size="mini" />
          </StyledLinkArea>
        </EventImage>
        <ResponsiveCardHeader type={definedTypographyTypes.h3}>
          <TildeTranslate text={title} />
        </ResponsiveCardHeader>
        <StyledInfoArea>
          <EventDetailList {...detailProps} />
        </StyledInfoArea>
      </a>
    </StyledCardWrapper>
  );
};

export default MediaLinkCard;
